import percent from '@pkg/utils/numbers/percent';
import config from '@/lib/config';
import defaultMetricGroup from '../../utils/defaultMetricGroup';
import updateMetrics from '../shared/updateMetrics';
import updateRootMetrics from '../shared/updateRootMetrics';

/**
 * Derives metrics for the role.
 *
 * @param {Object}
 *
 * @return {Object}
 */
export default function roleMetrics({
  activity,
  role,
  roleSet,
  group,
  metrics,
}) {
  const isNewRole = roleSet.has(role.uuid);
  const isVisibleActivity = activity?.__visibility === config.VISIBILITY.FULL;
  const isVisibleRole = role.__visibility === config.VISIBILITY.FULL;
  const isVisibleGroup = group?.__visibility === config.VISIBILITY.FULL;

  const factor = !activity
    ? 1
    : activity?.hours
      ? percent(activity.hours, role.__hours, 8) / 100
      : 0;

  const roleMetrics = {
    ...defaultMetricGroup(false),
    budget:
      isNewRole && role.__hours === 0 ? role.budget : role.budget * factor,
    fte: isNewRole && role.__hours === 0 ? role.fte : role.fte * factor,
    roles: isNewRole ? 1 : 0,
    managers: isNewRole && role.__manager ? 1 : 0,
    groups: isNewRole && group ? 1 : 0,
    activities: activity ? 1 : 0,
    hours: activity ? activity.hours : 0,
  };

  // Aggregate this roles's metrics with the total metrics.
  const total = updateMetrics({
    target: isNewRole ? defaultMetricGroup() : { ...role.__metrics.self.total },
    source: {
      ...roleMetrics,
    },
  });

  const incrementVisibleRole =
    (activity && isVisibleActivity) || (!activity && isVisibleRole);

  const visibleMetrics = {
    ...defaultMetricGroup(false),
    activities: isVisibleActivity ? 1 : 0,
    budget: incrementVisibleRole ? roleMetrics.budget : 0,
    fte: incrementVisibleRole ? roleMetrics.fte : 0,
    groups: isNewRole && isVisibleGroup ? 1 : 0,
    hours: isVisibleActivity ? activity.hours : 0,
    roles: isNewRole && isVisibleRole ? 1 : 0,
    managers: isNewRole && role?.__manager ? 1 : 0,
  };

  // Aggregate this roles's metrics with the visible metrics.
  const visible = updateMetrics({
    target: isNewRole
      ? defaultMetricGroup()
      : { ...role.__metrics.self.visible },
    source: {
      ...visibleMetrics,
    },
  });

  // If this is a new role, aggregate the root metrics with this role data.
  updateRootMetrics({
    entityMetrics: {
      ...roleMetrics,
      span: isNewRole && role?.__manager ? 1 : 0,
      groups: 0,
      activities: 0,
      hours: 0,
    },
    visibleMetrics: {
      ...visibleMetrics,
      groups: 0,
      activities: 0,
      hours: 0,
    },
    metrics,
  });

  return { total, visible };
}
